import { appNameFromPath, pathForApp } from "../runtime/stage-router.js";
export const OWNER_STAGE_NAMES = ["home", "wallet", "friends", "agents", "profile"];
/**
 * Display labels for the five first-party owner stages, shared by every shell nav
 * surface that lists them (`.tb-center` in topbar.ts, and — for the 3-item subset,
 * see `PMENU_PRIMARY_STAGE_NAMES` below — `.pmenu` in pmenu.ts) so the wording stays
 * in one place.
 */
export const OWNER_STAGE_LABELS = {
    agents: "Agents",
    friends: "Friends",
    home: "Home",
    profile: "Profile",
    wallet: "Wallet",
};
/**
 * `.pmenu`'s primary dock list, epic #1507 fidelity fix — a strict 3-item subset of the
 * five owner stages, matching the original skin's real `#pmenu` primary section verbatim
 * (`SKIN/index.html` lines 69-89): only Home/Agents/Friends are `.pmenu-item` rows there,
 * followed by the `.pmenu-more-btn` "Stages + more" trigger. Wallet is NOT a `.pmenu-item`
 * row in the original — it surfaces via the standalone `.wallet-status` pill
 * (`SKIN/index.html` lines 163-166, ported as `wallet-status.ts`). Profile is NOT a
 * `.pmenu-item` row either — it surfaces via `.pmenu-id` (`userChip`, `SKIN/index.html`
 * lines 93-96), already ported and unaffected by this list.
 *
 * `wallet` and `profile` stay in `OWNER_STAGE_NAMES` above (unaffected) because both routes
 * still resolve to real mounted stages — `app-shell.ts`'s `OWNER_STAGE_TAGS` map and
 * `topbar.ts`'s mobile `TB_LINKS` fallback both still need them; only the desktop `.pmenu`
 * primary list drops them as dock ROWS.
 */
export const PMENU_PRIMARY_STAGE_NAMES = ["home", "agents", "friends"];
export function ownerStagePath(name) {
    return pathForApp(name);
}
export function ownerStageFromPath(path) {
    const appName = appNameFromPath(path);
    return OWNER_STAGE_NAMES.includes(appName) ? appName : undefined;
}
//# sourceMappingURL=owner-stage-routes.js.map